export const GET_USER_DETAILS_INFO = 'GET_USER_DETAILS_INFO';
export const SERVICE_REQUEST_INFO = 'SERVICE_REQUEST_INFO';
export const DOCUMENT_REDIRECTION_INFO = 'DOCUMENT_REDIRECTION_INFO';
export const INCORRECT_DATA_NAME = 'INCORRECT_DATA_NAME';
export const GET_CONTRACT_NUMBERS = 'GET_CONTRACT_NUMBERS';
export const GET_PAYMENT_SCHEDULE = 'GET_PAYMENT_SCHEDULE';
export const PAYMENT_SCHEDULE_LOADER = 'PAYMENT_SCHEDULE_LOADER';
export const GET_ALL_CONTRACTS = 'GET_ALL_CONTRACTS';
export const PAYMENT_SCHEDULE_ERROR = 'PAYMENT_SCHEDULE_ERROR';
export const SET_CONTRACT_QUERY = 'SET_CONTRACT_QUERY';
export const SET_MONTH_QUERY = 'SET_MONTH_QUERY';
export const NO_SCHEDULE_DATA = 'NO_SCHEDULE_DATA';
export const PUSH_VIEW = 'PUSH_VIEW';
export const RESET_VIEW = 'RESET_VIEW';
export const SET_ORG = 'SET_ORG';
export const GET_CONTRACT_DETAILS = 'GET_CONTRACT_DETAILS';
export const CONTRACT_DETAILS_LOADER = 'CONTRACT_DETAILS_LOADER';
export const CONTRACT_DETAILS_ERROR = 'CONTRACT_DETAILS_ERROR';
export const RESET_STATE = 'RESET_STATE';
export const CONTRACT_NUMBERS_LOADER = 'CONTRACT_NUMBERS_LOADER';
export const CONTRACT_NUMBERS_ERROR = 'CONTRACT_NUMBERS_ERROR';
export const SERVICE_REQUEST_LOADER = 'SERVICE_REQUEST_LOADER';
export const SERVICE_REQUEST_ERROR = 'SERVICE_REQUEST_ERROR';
export const SERVICE_REQUEST_DETAILS = 'SERVICE_REQUEST_DETAILS';
export const POP_STATE = 'POP_STATE';
export const AUTHORIZED_USER_DETAILS = 'AUTHORIZED_USER_DETAILS';
export const MY_ACCOUNT_DETAILS = 'MY_ACCOUNT_DETAILS';
export const FETCH_LEIN_DEREGISTRATION_DATA = 'FETCH_LEIN_DEREGISTRATION_DATA';
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const UPDATE_ASSET_STATUS = 'UPDATE_ASSET_STATUS';
export const SET_ROLE = 'SET_ROLE';
export const SET_ROLE_ACCESS = 'SET_ROLE_ACCESS';
export const ASK_USER_TO_ENABLE_PUSH = 'ASK_USER_TO_ENABLE_PUSH';
